import { Keypair } from "@solana/web3.js";

export function generateNonce() {
    return Keypair.generate().publicKey.toString();
}
